<template>
  <div>
    <div class="login_box register_box">
      <div class="main_box">
        <div class="title clearfix">
          <span class="lang_forgetpwd">忘记密码</span>
        </div>
        <div class="xcontent">
          <div class="box">
            <div>
              <div class="input_box"><span class="lang_userinfo1">手机号：</span><input type="text" placeholder="请输入手机号" v-model="phnoeNo"></div>
              <div class="clearfix" style="margin-bottom:20px;">
                <div class="input_box input_box_left fl"><span class="lang_userinfo5">验证码：</span><input type="text" placeholder="请输入验证码" v-model="checkCode"></div>
                <div class="xbtn2 input_box_right fr getcode" @click="getCheckCode">{{timeDetail}}</div>
              </div>
              <div class="input_box"><span class="lang_userinfo2">密码：</span><input type="password" placeholder="请输入密码" v-model="password"></div>
              <div class="input_box"><span class="lang_userinfo4">确认密码：</span><input type="password" placeholder="请确认密码" v-model="agPassword"></div>
            </div>
            <div class="xbtn lang_register" @click="getForgetpwd">{{$t('menu.submit')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      timeDetail: "发送验证码",
      countdown: 30,
      password: "",
      phnoeNo: "",
      checkCode: "",
      agPassword: ""
    };
  },
  methods: {
    getCheckCode(){
      var obj = document.getElementsByClassName("getcode");
      var that = this;
      if (this.phnoeNo == "") {
        layer.msg("请输入手机号", {
          time: 1500
        });
        return;
      }
      var postData = {
        phoneNum: this.phnoeNo,
        type: 2
      }
      this.$http.post(this,'/noAuth/user/smsCheckCode',this.$Qs.stringify(postData)).then(res=>{
        if(res){
          layer.msg(
              "发送成功",
              {
                time: 1000
              },
              ()=>{
                this.getTime();
              }
            );
        }
      })
    },
    getTime() {
      var that = this;
      var obj = document.getElementsByClassName("getcode");
      if (this.countdown == 0) {
        obj.disabled = false;
        $(".getcode").css("background", "#234EA0");
        this.timeDetail = "发送验证码";
        this.countdown = 30;
        return;
      } else {
        obj.disabled = true;
        //  obj.style.setProperty('background','#666');
        $(".getcode").css("background", "#999");
        this.timeDetail = this.countdown + "S后重新发送";
        this.countdown--;
        setTimeout(function() {
          that.getTime();
        }, 1000);
      }
    },
    getForgetpwd: function() {
      var that = this;
      var number = /^[1][3,4,5,7,8][0-9]{9}$/; //手机
      if (this.phnoeNo == "") {
        layer.msg("请输入手机号", {
          time: 1500
        });
        return;
      }
      if (!number.exec(this.phnoeNo)) {
        layer.msg("手机号格式不正确", {
          time: 1500
        });
        return;
      }
      if (this.checkCode == "") {
        layer.msg("请输入验证码", {
          time: 1500
        });
        return;
      }
      if (this.password == "") {
        layer.msg("请输入密码", {
          time: 1500
        });
        return;
      }
      if (this.agPassword == "") {
        layer.msg("请输入确认密码", {
          time: 1500
        });
        return;
      }
      if (this.password != this.agPassword) {
        layer.msg("密码与确认密码不一致", {
          time: 1500
        });
        return;
      }
      var putData = {
          phoneNum: this.phnoeNo,
          password: this.password,
          checkCode: this.checkCode,
          type: 2
        }
      this.$http.put(this,"/noAuth/user/resetPwd",this.$Qs.stringify(putData)).then(res=>{
        if(res){
          var accountName = res.data.accountName;
          var confirm = layer.open({
              content: "重置密码成功<br />用户名:" + accountName,
              yes: (index, layero)=>{
                //按钮【按钮一】的回调
                layer.close(confirm);
                localStorage.clear();
                this.$router.push('/')
              }
            });
        }
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/forget-pwd.vue